// Author YuJiaBei
// Date 2020-11-12 10:33:15

import * as model from "@/model/em/inspection/InspectionCategoryModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.InspectionCategory(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_INSPECTION_URL,
    })
    .buildStore()
